import React, { useState } from 'react'
import AddEditRecordPage from '../AddEditViewRecord.page'
import { HybridLayoutIntakeWrapper } from '../../components/hybird-layout/HybridLayoutIntakeWrapper'
import { AddEditRecordPageProps } from '../../types/pages.types'
import { LayoutResponseType } from '@app-store'

export const IntakeReviewLayoutWrapper: React.FC<AddEditRecordPageProps> = (
  props
) => {
  const [isHybrid, setIsHybrid] = useState<boolean>(false)
  const hybridDetectionRef = React.useRef<LayoutResponseType | undefined>(
    undefined
  )
  const hybridDetected = (data: LayoutResponseType) => {
    hybridDetectionRef.current = data
    setIsHybrid(true)
  }
  return (
    <React.Fragment>
      {isHybrid ? (
        <HybridLayoutIntakeWrapper
          layoutData={hybridDetectionRef?.current}
          recordId={props?.id ?? ''}
          hybridDetected={hybridDetected}
          {...props}
        />
      ) : (
        <AddEditRecordPage {...props} hybridDetected={hybridDetected} />
      )}
    </React.Fragment>
  )
}
